// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import IconClose from "@conklin/XDL/Icons/IconClose";
import IconNotificationError from "@conklin/XDL/Icons/IconNotificationError";
import IconNotificationInfo from "@conklin/XDL/Icons/IconNotificationInfo";
import IconNotificationSuccess from "@conklin/XDL/Icons/IconNotificationSuccess";
import IconNotificationWarning from "@conklin/XDL/Icons/IconNotificationWarning";
import { buttonTransparent } from "@conklin/XDL/PreStyle/button";
import { xBaseTheme } from "@conklin/XDL/types";
import { color } from "@conklin/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import ToastPropsDefault, { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css, ThemeProps } from "styled-components";

export default {
    defaultProps: {
        ...ToastPropsDefault,
        mergeCss: true,
        closeButtonProps: {
            mergeCss: true,
            color: "transparent",
            buttonType: "solid",
            shape: "pill",
            css: css`
                position: absolute;
                top: 0;
                right: 0;
                border: 0;
                width: 24px;
                height: 24px;
                padding: 0;
                ${buttonTransparent}
                &:hover ${IconWrapper} {
                    color: ${color("common.ui9")};
                }
            `,
            size: 24,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: IconClose,
            size: 12,
            color: "common.ui6",
        },
        iconProps: {
            mergeCss: true,
            size: 18,
            css: css`
                margin-top: 2px;
                margin-right: 10px;
            `,
        },
        iconSrcByMessage: {
            success: IconNotificationSuccess,
            warning: IconNotificationWarning,
            danger: IconNotificationError,
            info: IconNotificationInfo,
        },
        bodyTypographyProps: {
            mergeCss: true,
            css: css`
                word-wrap: break-word;
                white-space: pre-wrap;
                width: calc(100% - 28px);
                & > ${TypographyStyle}, & > div > ${TypographyStyle} {
                    ${({ theme }: ThemeProps<BaseTheme>) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    font-size: 12px;
                                    line-height: 16px;
                                `,
                                null,
                                css`
                                    font-size: 14px;
                                    line-height: 22px;
                                `,
                                null,
                                null,
                            ],
                            "min",
                        )}

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            `,
            color: "text.main",
        },
        cssOverrides: {
            toast: css`
                border-style: solid;
                border-width: 1px;
                background: ${({ messageType }: any) => color(`${messageType}.light`)};
            `,
            toastBody: css`
                &&& {
                    margin: 0;
                    width: 100%;
                    align-items: center;
                }
                align-items: flex-start;
                padding: 14px 12px;
                margin-top: 2px;
            `,
        },
    },
    toasterProps: {
        ...toasterPropsDefault,
        position: "top",
    },
} as xBaseTheme["toast"];
